var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 78,
    viewBox: "0 0 98 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_127_40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.193 2.05882C80.6868 0.617647 75.734 0 70.9842 0C63.0679 0 54.5426 1.64706 48.6561 6.17647C42.7696 1.64706 34.2444 0 26.3281 0C18.4118 0 9.88649 1.64706 4 6.17647V66.5C4 67.5294 5.01491 68.5588 6.02982 68.5588C6.43579 68.5588 6.63877 68.3529 7.04474 68.3529C12.5253 65.6765 20.4416 63.8235 26.3281 63.8235C34.2444 63.8235 42.7696 65.4706 48.6561 70C54.1367 66.5 64.0828 63.8235 70.9842 63.8235C77.6826 63.8235 84.584 65.0588 90.2675 68.1471C90.6735 68.3529 90.8765 68.3529 91.2824 68.3529C92.2973 68.3529 93.3123 67.3235 93.3123 66.2941V6.17647C90.8765 4.32353 88.2377 3.08824 85.193 2.05882ZM85.193 57.6471C80.7273 56.2059 75.8558 55.5882 70.9842 55.5882C64.0828 55.5882 54.1367 58.2647 48.6561 61.7647V14.4118C54.1367 10.9118 64.0828 8.23529 70.9842 8.23529C75.8558 8.23529 80.7273 8.85294 85.193 10.2941V57.6471Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_127_40",
    x: 0,
    y: 0,
    width: 97.3123,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_40"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_127_40",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractLogo);
export default __webpack_public_path__ + "static/media/ContractLogo.25c32ce5133ffb9e4ed6f7934cce0a91.svg";
export { ForwardRef as ReactComponent };